
import { Component, effect, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-in-place-validator',
  templateUrl: './in-place-validator.component.html',
  imports: [FormsModule, ReactiveFormsModule]
})
export class InPlaceValidatorComponent {
  public isValid = true;
  public formControl = new FormControl();
  public readonly text = input.required<string>();
  public readonly validators = input.required<ValidatorFn[]>();


  constructor() {
    effect(() => {
      this.formControl.setValidators(this.validators());
      this.formControl.setValue(this.text());
      this.isValid = this.formControl.status === 'VALID';
    });
  }
}
